import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f5b10ac")

_pushScopeId("data-v-4f5b10ac")
const _hoisted_1 = { class: "table-bg" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = {
  key: 0,
  class: "p-mr-2 badge bg-red"
}
const _hoisted_4 = {
  key: 1,
  class: "p-mr-2 badge bg-green"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("-")
_popScopeId()

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from '@/store/store';
import { showToast } from '@/services/error-management.service';
import { client } from '@/api/client-v2';
import { useI18n } from 'vue-i18n';
import AddNewManager from './AddNewManager.vue';
import { User } from '@/generated-sources/anagrafica-api';
import Column from 'primevue/column';
import Actions from './Actions.vue';
import { ManagerUser } from '@/api/types';


export default _defineComponent({
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const LIMIT = 15;
const clubManagers = ref<ManagerUser[]>();
const total = ref(0);
const page = ref(1);
const loading = ref(false);
const first = computed(() => (page.value - 1) * LIMIT);


/* COMPUTED */
const myClubId = computed(() => {
  return store.getters.getMyClub.club_id;
});

const getClubManagers = async () => {
  try {
    loading.value = true;
    const { data } = await client.getManagers({
      clubId: myClubId.value,
      page: page.value,
      limit: LIMIT,
    });
    clubManagers.value = data.values;
    total.value = data.total;
  } catch (error) {
    console.error('Error fetching users:', error);
    clubManagers.value = [];
    total.value = 0;
    page.value = 1;
    showToast('si è verificato un errore')
  } finally {
    loading.value = false;
  }
}


const pageEvent = (event: { page: number }) => {
  page.value = event.page + 1;
  getClubManagers();
}

onMounted(() => {
  getClubManagers()
})

onUnmounted(() => {
  clubManagers.value = [];
  total.value = 0;
  page.value = 1;
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: clubManagers.value,
      lazy: "",
      paginator: "",
      rows: 15,
      "page-link-size": 10,
      first: _unref(first),
      "total-records": total.value,
      loading: loading.value,
      onPage: pageEvent,
      size: "large",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: "{first} a {last} di {totalRecords} utenti",
      paginatorPosition: "top"
    }, {
      paginatorLeft: _withId(() => [
        _createVNode(AddNewManager, { onUpdated: getClubManagers })
      ]),
      empty: _withId(() => [
        _createVNode("p", null, _toDisplayString(_unref(t)('no_records')), 1)
      ]),
      default: _withId(() => [
        _createVNode(_unref(Column), {
          header: _unref(t)('name') + ' ' + _unref(t)('surname')
        }, {
          body: _withId((slotProps) => [
            _createVNode("div", _hoisted_2, [
              (slotProps.data.manager_status === 'blocked')
                ? (_openBlock(), _createBlock("span", _hoisted_3))
                : (_openBlock(), _createBlock("span", _hoisted_4)),
              _createVNode(_component_router_link, {
                to: { name: 'user-details', params: { id: slotProps.data.id } },
                class: "color-blue p-text-bold underline"
              }, {
                default: _withId(() => [
                  (slotProps.data)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(slotProps.data?.nome) + " " + _toDisplayString(slotProps.data?.cognome), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _hoisted_5
                      ], 64))
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          header: _unref(t)('email')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data?.email), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          header: _unref(t)('phonenumber_abbreviated')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data?.cell), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), { class: "actions-column" }, {
          body: _withId(({ data }) => [
            _createVNode(Actions, {
              user: data,
              onUpdated: getClubManagers
            }, null, 8, ["user"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "first", "total-records", "loading"])
  ]))
}
}

})